import React, {Component} from 'react';
import './Dialogs.min.css';

class RestartDialog extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="dlg_quote" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Restart Design</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(false)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_white">
                            Restarting the design will erase your current build.  Do you want to continue?
                        </div>
                        <div id="dlg_quote_btn" className="dlg_btn" onClick={() => this.props.onClick(true)}>RESTART</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RestartDialog;
